/* eslint-disable no-empty */
import { useState } from 'react';
import { Lock } from 'lucide-react';
import { useProgram } from './ProgramContext';

const PasswordGate = () => {
  const { login } = useProgram();
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError(''); setBusy(true);
    try {
      await login((password || '').trim());
    } catch (err) {
      setError(err.message || 'Wrong password.');
    }
    setBusy(false);
  };

  return (
    <div className="g33-program g33-gate" data-testid="program-gate" style={{
      minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center',
      padding: '24px', background: 'var(--g33-cream)',
    }}>
      <form
        onSubmit={submit}
        autoComplete="off"
        style={{
          width: '100%', maxWidth: 420, background: 'var(--g33-cream-soft)',
          border: '1px solid var(--g33-ligne)', padding: '56px 40px',
        }}
      >
        <div style={{ display: 'flex', justifyContent: 'center', marginBottom: 24 }}>
          <div style={{
            width: 48, height: 48, border: '1px solid var(--g33-or)', borderRadius: '50%',
            display: 'flex', alignItems: 'center', justifyContent: 'center',
            background: 'rgba(201,169,97,0.06)',
          }}>
            <Lock size={18} style={{ color: 'var(--g33-or)' }} />
          </div>
        </div>

        <div className="g33-eyebrow" style={{ textAlign: 'center', marginBottom: 12 }}>
          Gate 33 · Confidential
        </div>
        <h1 className="g33-display" style={{ fontSize: 28, textAlign: 'center', marginBottom: 36 }}>
          Restricted access
        </h1>

        {error && (
          <div data-testid="program-error" style={{
            marginBottom: 16, fontSize: 12, textAlign: 'center', color: 'var(--g33-alert)',
            letterSpacing: '0.04em',
          }}>
            {error}
          </div>
        )}

        {/* honeypot for autofill */}
        <input
          type="text" name="username" autoComplete="username" tabIndex={-1} aria-hidden="true" readOnly
          style={{ position: 'absolute', left: '-9999px', width: 1, height: 1, opacity: 0 }}
        />

        <input
          type="password"
          data-testid="program-password"
          name="g33-program-secret"
          autoComplete="new-password"
          autoCorrect="off" autoCapitalize="off" spellCheck="false"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          placeholder="Password"
          autoFocus required
          style={{
            width: '100%', padding: '16px 20px', textAlign: 'center',
            background: 'var(--g33-cream)', border: '1px solid var(--g33-ligne)',
            fontFamily: 'var(--g33-font-body)', fontSize: 14, letterSpacing: '0.16em',
            color: 'var(--g33-noir)', outline: 'none',
          }}
          onFocus={(e) => e.target.style.borderColor = 'var(--g33-or)'}
          onBlur={(e) => e.target.style.borderColor = 'var(--g33-ligne)'}
        />

        <div style={{ marginTop: 8, textAlign: 'right' }}>
          <button
            type="button"
            onClick={() => { setPassword(''); setError(''); }}
            className="g33-btn-ghost"
            style={{ fontSize: 10 }}
          >
            Clear
          </button>
        </div>

        <button
          type="submit"
          data-testid="program-submit"
          disabled={busy || !password}
          className="g33-btn-primary"
          style={{ width: '100%', justifyContent: 'center', marginTop: 12 }}
        >
          {busy ? 'Checking…' : 'Enter'}
        </button>

        <p style={{
          marginTop: 24, textAlign: 'center', fontSize: 10,
          letterSpacing: '0.22em', color: 'var(--g33-grey-warm)',
          textTransform: 'uppercase',
        }}>
          {password.length} chars typed
        </p>
      </form>
    </div>
  );
};

export default PasswordGate;
